<template>
    <v-dialog
        class="bind-mobile-dialog"
        :open="name === 'replaceMobileDialog'"
        title="绑定手机号"
        @close="$emit('update:name', '')"
    >
        <div slot="subtitle">
            <p>请使用新手机号进行绑定，</p>
            <p>绑定成功后原先绑定的手机和微信号都将解绑</p>
        </div>
        <div class="body">
            <div class="dialog-main-content">
                <v-form
                    ref="form"
                    class="bind-form"
                    @submit.prevent="formormSubmit"
                >
                    <v-form-item
                        name="mobile"
                        error-placement="top-right"
                        :rules="formRules.mobile"
                    >
                        <span class="form-label">手机号</span>
                        <v-form-input
                            ref="formInput"
                            name="mobile"
                            :value="form.mobile"
                        />
                        <international-tel-input
                            ref="internationalTelInput"
                            v-model="form.mobile"
                            width="302"
                            @blur="$refs.formInput.triggerBlur()"
                        />
                    </v-form-item>
                    <v-form-item
                        name="sms_code"
                        error-placement="top-right"
                        :rules="formRules.sms_code"
                    >
                        <span class="form-label">验证码</span>
                        <v-input
                            v-model="form.sms_code"
                            kind="simple"
                            style="width:190px;"
                        />
                        <v-button
                            class="captch-btn"
                            :disabled="isCountdown || !form.mobile"
                            :loading="sendCaptchaLoading"
                            @click="sendCaptcha"
                        >
                            {{ isCountdown ? `${countdown}s` : '获取验证码' }}
                        </v-button>
                    </v-form-item>
                    <v-form-item class="btn-row">
                        <v-button
                            type="submit"
                            class="btn"
                            size="large"
                            kind="primary"
                            :loading="bindLoading"
                        >
                            绑定手机
                        </v-button>
                        <v-button
                            class="btn"
                            size="large"
                            @click="handleReturnValid"
                        >
                            返回
                        </v-button>
                    </v-form-item>
                </v-form>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import InternationalTelInput from '@/components/international-tel-input';
import { encryptTel } from '@/components/international-tel-input/utils';
import Gateway from '@/utils/Gateway';
import WECHAT from './const';

const GET_CAPTCHA = '/v1/basic.account.account_web.AccountWeb/SendLoginMSG';
const DEFAULT_FORM = {
    mobile: '',
    sms_code: '',
    is_sync_login: false,
};
const COUNT_DOWN_INIT = 60;
export default {
    filters: {
        encryptTel,
    },
    components: {
        InternationalTelInput,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        const vm = this;
        return {
            WECHAT,
            bindLoading: false,
            sendCaptchaLoading: false,
            formCountdown: COUNT_DOWN_INIT,
            countdownTimer: null,
            countdown: COUNT_DOWN_INIT,
            form: {
                ...DEFAULT_FORM,
            },
            formRules: {
                mobile: [
                    {
                        validate() {
                            return vm.$refs.internationalTelInput.getTel().length > 0;
                        },
                        message: '手机号不能为空',
                        trigger: 'blur',
                    },
                    {
                        validate() {
                            return vm.$refs.internationalTelInput.isValid();
                        },
                        message: '手机号格式不正确',
                        trigger: 'blur',
                    },
                ],
                sms_code: [
                    {
                        required: true,
                        message: '验证码不能为空',
                        trigger: 'blur',
                        trim: false,
                    },
                    {
                        validate(value) {
                            return /^\d{6}$/.test(value);
                        },
                        message: '验证码格式错误',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    computed: {
        isCountdown() {
            return this.countdown < COUNT_DOWN_INIT;
        },
    },
    methods: {
        handleReturnValid() {
            this.$emit('on-return-validate');
        },
        clearCountdownTimer() {
            clearInterval(this.countdownTimer);
        },
        startCountdown() {
            /* eslint-disable no-plusplus */
            this.countdown--;
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= -1) {
                    this.clearCountdownTimer();
                    this.countdown = COUNT_DOWN_INIT;
                }
            }, 1000);
            this.$once('hook:beforeDestroy', this.clearCountdownTimer);
        },
        sendCaptcha() {
            // 如果手机号码不合法，则不能获取验证码
            if (!this.$refs.internationalTelInput.isValid()) {
                return;
            }
            this.bindLoading = true;
            const form = {
                mobile: this.form.mobile,
                type: 1,
            };
            Gateway.post(GET_CAPTCHA, form)
                .then(() => {
                    // data.code = 1003 [1003]验证码发送频繁，请稍后再试
                    this.startCountdown();
                    this.bindLoading = false;
                })
                .catch((err) => {
                    this.bindLoading = false;
                    this.$message.error(err || '网络故障，请稍后再试');
                    throw err;
                });
        },
        formormSubmit() {
            this.$emit('validate-tel-success');
        },
    },
};
</script>

<style lang="less">
.bind-mobile-dialog {
    .v-dialog__subtitle {
        margin-top: 5px;
        font-size: 14px;
        line-height: 20px;
        color: #ff4222;
        text-align: center;
    }
    .v-dialog__content {
        width: 400px;
        padding: 40px 0 60px;
        .v-dialog__body {
            margin-top: 35px;
        }
    }
    .body {
        .dialog-main-content {
            padding: 0 40px;
            margin-top: 45px;
            .bind-form {
                .form-label {
                    margin-right: 15px;
                }
                .captch-btn {
                    width: 102px;
                    right: -112px;
                    position: absolute;
                }
                .btn-row {
                    margin-top: 45px;
                    .v-form-item__input {
                        width: 100%;
                        .btn {
                            width: 168px;
                            float: none;
                            &:not(:first-child) {
                                margin-left: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
